// removed by extract-text-webpack-plugin
module.exports = {"error":"FormError__error___1JHg4"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/components/FormError/FormError.css
// module id = 1204
// module chunks = 0